<template>
  <header id="nav_fixed">
    <div class="nav_item logo_item">
      <router-link to="/">
        <img class="logo" src="../../public/icon/kslab-logo.png" alt="logo">
      </router-link>
    </div>

    <div id="menu_container" class="nav_item">
      <router-link class="menu_item sub_font" to="/">HOME</router-link>
      <router-link class="menu_item sub_font" to="/about">ABOUT</router-link>
      <router-link class="menu_item sub_font" to="/business">BUSINESS</router-link>
      <router-link class="menu_item sub_font" to="/contact">CONTACT</router-link>
    </div>

    <div id="small_nav">
      <div class="logo_item">
        <router-link to="/">
          <img class="logo" src="../../public/icon/kslab-logo.png" alt="logo">
        </router-link>
      </div>

      <div id="small_menu" class="small_menu_container">
        <header class="header">
          <nav class="header__nav">
            <ul class="header__navbar">
              <li class="header__item">
                <a href="#" class="header__link">
                  <transition name="slide-fade">
                    <!-- Header Navigation Menu Icons -->
                    <button class="header--button" v-if="show" key="on" @click="show = false">
                      <svg viewBox="0 0 24 24" class="header--icon">
                        <title>Close</title>
                        <path d="M0 0h24v24H0V0z" fill="none" />
                        <path fill="currentColor" d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
                      </svg>
                    </button>
                    <button class="header--button" v-else key="off" @click="show = true">
                      <svg viewBox="0 0 24 24" class="header--icon">
                        <title>Navigation Menu</title>
                        <path fill="currentColor" d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z" />
                      </svg>
                    </button>
                  </transition>
                </a>
                <!-- Dropdown Menu -->
                <transition name="dropdown">
                  <div class="dropdown__menu" v-bind:class="{ active: show }" v-if="show">
                    <ul class="dropdown__menu-nav">
                      <li class="dropdown__menu-item">
                        <router-link class="dropdown__menu-link" to="/">
                          <div class="dropdown__menu-text"> HOME </div>
                        </router-link>
                      </li>
                      <li class="dropdown__menu-item">
                        <router-link class="dropdown__menu-link" to="/about">
                          <div class="dropdown__menu-text"> ABOUT </div>
                        </router-link>
                      </li>
                      <li class="dropdown__menu-item">
                        <router-link class="dropdown__menu-link" to="/business">
                          <div class="dropdown__menu-text"> BUSINESS </div>
                        </router-link>
                      </li>
                      <li class="dropdown__menu-item">
                        <router-link class="dropdown__menu-link" to="/contact">
                          <div class="dropdown__menu-text"> CONTACT </div>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </transition>
              </li>
            </ul>
          </nav>
        </header>
      </div>

    </div>

  </header>
</template>

<script>
export default {
  el: "small_menu",
  data() {
    return {
      show: false
    }
  },

  methods: {
    toggleShow() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="scss">
#nav_fixed {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 64px !important;
  background-color: white;
  font-size: 17px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  border-bottom: 1px solid #e9ecef
}

.logo {
  width: 42px;
  height: 60px;
}

.logo_item {
  width: 20%;
  padding-left: 40px;
  padding-top: 3px;
}

#menu_container {
  justify-content: flex-end;
  width: 80%;
  display: flex;
  flex-direction: row;
  padding-right: 40px;
}

.menu_item {
  padding-top: 12px;
  padding-left: 30px;
}

#menu {
  width: 22px;
  height: 22px;
}

#nav_fixed a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

#nav_fixed a.router-link-exact-active {
  color: rgb(238, 92, 48);
  text-decoration: none;
}

#nav_fixed a:hover {
  color: rgb(240, 134, 101);
}

/* 767px 이하 */
@media screen and (max-width: 767px) {
  .nav_item {
    display: none;
  }

  #menu_container {
    display: none;
  }

  #small_nav {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
  }

  .small_menu_container {
    width: 80%;
    height: 64px;
    padding-top: 15px;
    padding-right: 15px;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  #click_menu_container {
    width: 100%;
    position: absolute;
    top: 64px;
    right: 0px;
    padding-left: 10px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
  }
}

/* 767px 이상 */
@media screen and (min-width: 767px) {
  #small_nav {
    display: none;
  }
}

// 드롭다운
ul {
  list-style:none;
}
:root {
  --font-primary: 'Open Sans', sans-serif;
  --color-gray: #dadce0;
}

// Global

*,
::after,
::before {
  box-sizing: border-box;
}

body {
  font-size: 1rem;
  -webkit-text-size-adjust: 100%;
  font-family: var(--font-primary);
  overflow: hidden;
}
hr {
  border: 0;
  height: 0;
  margin: 1.5rem 0;
  border-top: 1px solid var(--color-gray);
}

// Header Menu

.header {
  padding: 0.1rem 1rem 0.5rem 1rem;
  &__nav {
    position: relative;
  }
  &__navbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  &__item {
    padding: 1rem;
  }
  &--icon {
    width: 1.65rem;
    height: 1.65rem;
  }
  &--button {
    top: 0;
    right: 0;
    position: absolute;
    margin: 0;
    padding: 0;
    color: gray;
    cursor: pointer;
    border: 1px solid transparent;
    background-color: transparent;
    &:focus {
      outline: 0;
    }
  }
}

// Dropdown Menu

.dropdown__menu {
  top: 100%;
  right: 0;
  position: absolute;
  z-index: 10;
  height: 16rem;
  min-width: 200px;
  margin-top: 1rem;
  overflow-y: auto;
  padding: 1rem 0.5rem 1rem 0.5rem;
  border-radius: 12px;
  background-color: white;
  border: 1px solid var(--color-gray);
  background-clip: padding-box;
  &-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.6);
    padding: 0.8rem 0 0.8rem 2rem;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    border-radius: 0 50px 50px 0;
    &:hover {
      color: #17bf63;
      background-color: rgba(240, 134, 101, 0.1);
    }
  }
  &-svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  &-text {
    font-weight: 300;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

// Animation Menu Icon

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s;
}
.slide-fade-enter,
.slide-fade-leave-active {
  opacity: 0;
}
.slide-fade-enter {
  transform: translateX(31px);
}
.slide-fade-leave-active {
  transform: translateX(-31px);
}

// Dropdown Menu Animation

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 1s;
}
.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

// Wrapper

.main {
  margin: 6rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &__subtitle {
    color: #4f5959;
    font-weight: 100;
    margin-bottom: 2rem;
  }
  &__link {
    margin-right: 1.5rem;
    display: inline-block;
    &:last-child {
      margin-right: 0;
    }
  }
  &__svg {
    width: 2rem;
    height: 2rem;
    opacity: 0.6;
    color: #94a2b0;
    &:hover {
      color: #ffad1f;
    }
  }
}

</style>
